import React, { useEffect, useState } from "react"; // ✅ added useState
import AOS from "aos";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import "aos/dist/aos.css";
import {
  FaLaptopCode,
  FaPaintBrush,
  FaReact,
  FaDatabase,
  FaBriefcase,
  FaNodeJs,
  FaJs,
  FaFigma,
  FaHtml5,
  FaCss3Alt,
} from "react-icons/fa";
import "./AboutCard.css";
import ModelViewerComponent from "./ModelViewerComponent";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Acc from "./pages/Acc";

function AboutCard() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  // ✅ Project filter state
  const [filter, setFilter] = useState("All");

  // ✅ Project data
  const projects = [
    {
      title: "CFHRSW",
      description: "NGO Website",
      category: "Web Apps",
      image: "images/ngo.png",
      tech: ["React", "CSS", "API"],
      link: "https://cfhrsw.org",
    },
    {
      title: "Radha Enterprises",
      description: "Interior Designing Website",
      category: "UI Design",
      image: "images/re.png",
      tech: ["HTML", "CSS", "JavaScript"],
      link: "https://radhaenterprises.co.in",
    },
    {
      title: "Weather Forecast",
      description: "OpenWeather & GeoDB API",
      category: "Mini Projects",
      image: "images/weather.png",
      tech: ["React", "API", "Tailwind"],
      link: "https://bespoke-puppy-f8db27.netlify.app/",
    },
    {
      title: "Quicklearn",
      description: "B.Tech RTU study material",
      category: "Web Apps",
      image: "images/quick.webp",
      tech: ["Figma", "React", "CSS3"],
      link: "https://quicklearn-rtu.netlify.app/",
    },
  ];

  const filteredProjects =
    filter === "All" ? projects : projects.filter((p) => p.category === filter);

  return (
    <section className="about-section" id="about">
      <div className="about-container">
        {/* ---------- ABOUT ---------- */}
        <div className="about-top" data-aos="fade-up">
          <div className="about-text">
            <h2>About Me</h2>
            <h4>Web Developer & UI/UX Enthusiast</h4>

            <div className="about-line">
              <FaLaptopCode className="about-icon" />
              <p>
                Passionate <strong>Front-end Developer</strong> skilled in
                crafting responsive and high-performance web interfaces using
                modern technologies like <strong>React.js</strong> and{" "}
                <strong>JavaScript</strong>.
              </p>
            </div>

            <div className="about-line">
              <FaPaintBrush className="about-icon" />
              <p>
                With an eye for <strong>UI/UX design</strong>, I create visually
                appealing layouts using <strong>Figma</strong> and{" "}
                <strong>Canva</strong>, blending creativity with technical
                precision.
              </p>
            </div>

            <div className="about-line">
              <FaDatabase className="about-icon" />
              <p>
                Currently expanding into <strong>Back-end Development</strong>{" "}
                with <strong>Node.js</strong> and <strong>MySQL</strong> to
                build complete full-stack applications.
              </p>
            </div>
          </div>

          <div className="about-model" data-aos="fade-left">
            <ModelViewerComponent />
          </div>
        </div>

        {/* ---------- TECH STACK ---------- */}
        <div className="tech-stack" data-aos="fade-up">
          <h2>Tech Stack</h2>
          <div className="tech-icons">
            <div className="tech-item" data-aos="zoom-in" data-aos-delay="100">
              <FaReact className="tech-icon react" />
              <span>React</span>
            </div>
            <div className="tech-item" data-aos="zoom-in" data-aos-delay="200">
              <FaJs className="tech-icon js" />
              <span>JavaScript</span>
            </div>
            <div className="tech-item" data-aos="zoom-in" data-aos-delay="300">
              <FaNodeJs className="tech-icon node" />
              <span>Node.js</span>
            </div>
            <div className="tech-item" data-aos="zoom-in" data-aos-delay="700">
              <FaHtml5 className="tech-icon html" />
              <span>HTML5</span>
            </div>
            <div className="tech-item" data-aos="zoom-in" data-aos-delay="400">
              <FaDatabase className="tech-icon mysql" />
              <span>MySQL</span>
            </div>
            <div className="tech-item" data-aos="zoom-in" data-aos-delay="500">
              <FaFigma className="tech-icon figma" />
              <span>Figma</span>
            </div>
            <div className="tech-item" data-aos="zoom-in" data-aos-delay="800">
              <FaCss3Alt className="tech-icon css" />
              <span>CSS3</span>
            </div>
          </div>
        </div>

        {/* ---------- INTERNSHIP INSIGHTS ---------- */}
        <Acc/>

        {/* ---------- PROJECTS ---------- */}
        <div className="about-projects" data-aos="fade-up">
          <h2>Web Development Projects</h2>

          {/* Filter Buttons */}
          <div className="filter-buttons">
            {["All", "Web Apps", "UI Design", "Mini Projects"].map((cat) => (
              <button
                key={cat}
                className={`filter-btn ${filter === cat ? "active" : ""}`}
                onClick={() => setFilter(cat)}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Swiper Carousel */}
          <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={30}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            breakpoints={{
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            className="project-swiper"
          >
            {filteredProjects.map((proj, index) => (
              <SwiperSlide key={index}>
                <a
                  href={proj.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-card"
                >
                  <img src={proj.image} alt={proj.title} />
                  <div className="project-info">
                    <h4>{proj.title}</h4>
                    <p>{proj.description}</p>
                    <div className="project-tags">
                      {proj.tech.map((tag, i) => (
                        <span key={i} className="tech-tag">
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default AboutCard;
